import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { paths, TransferChartExceptionCodes } from '@app/constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-transfer-exception-dialog',
  templateUrl: './transfer-exception-dialog.component.html',
  styleUrls: ['./transfer-exception-dialog.component.scss']
})
export class TransferExceptionDialogComponent implements OnInit {
  transferChartExceptionCodes = TransferChartExceptionCodes;
  errorMessage: string;

  constructor(
    public dialogRef: MatDialogRef<TransferExceptionDialogComponent>,
    private router: Router,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    switch (this.data.res.code) {
      case this.transferChartExceptionCodes.TransferChartExpired:
        this.setErrorMessage('CHART_MANAGER.TRANSFER_CHART.TRANSFER_NO_AVAILABLE.EXPIRED');
        break;

      case this.transferChartExceptionCodes.TransferChartCanceled:
        this.setErrorMessage('CHART_MANAGER.TRANSFER_CHART.TRANSFER_NO_AVAILABLE.CANCELLED');
        break;

      case this.transferChartExceptionCodes.TransferChartAlreadyAccepted:
        this.setErrorMessage('CHART_MANAGER.TRANSFER_CHART.TRANSFER_NO_AVAILABLE.ALREADY_ACCEPTED');
        break;

      case this.transferChartExceptionCodes.InvalidEmailInvitation:
        this.setErrorMessage('CHART_MANAGER.TRANSFER_CHART.TRANSFER_NO_AVAILABLE.INVALID_EMAIL_INVITATION');
        break;

      default:
        break;
    }
  }

  setErrorMessage(translateKey: string) {
    this.translateService.get(translateKey).subscribe((value) => {
      this.errorMessage = value;
    });
  }

  confirm() {
    this.dialogRef.close();
    this.router.navigate([paths.CHARTS_MANAGER, paths.MY_CHART], { replaceUrl: true });
  }

}
